import script from "./upsell.vue?vue&type=script&lang=js"
export * from "./upsell.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__